import {
  type AssertionLoginResult,
  ChallengeType,
  type RequestAttestation,
} from '~/interfaces/auth';

import { LoginHandler } from './login-handler';

export class Auth0Handler extends LoginHandler<
  Omit<RequestAttestation, 'data'>,
  AssertionLoginResult
> {
  protected transformRequestBody(
    body: Omit<RequestAttestation, 'data'>,
  ): AssertionLoginResult {
    return {
      assertion_result: {
        challengeType: ChallengeType.OAUTH_REDIRECT,
        value: {
          code: body.assert.code,
          state: body.assert.state,
        },
        originalChallengeParams: {
          state: body.assert.state,
          timestamp: Date.now(),
        },
      },
      extra_context: {},
    };
  }
}
